'use strict';

require('./chunk-d7703e54.js');
require('./variadic.js');
require('./chunk-e6d921c6.js');
require('./head.js');
require('./tail.js');
require('./copy.js');
var _get = require('./_get.js');
require('./chunk-fac2c876.js');
var _set = require('./_set.js');

function update(ks, f, o) {
  return _set(ks, f(_get(ks, o)), o);
}

module.exports = update;
